import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { Brand } from '../../models/Brands';
import { BrandDiscoverModel } from '../../models/Discover';

interface IBrandService {
  getMostPopular: (
    categoryId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<Brand[]>>;
  getOnlineBrands: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<BrandDiscoverModel[]>>;
  getBrandsByCity: (
    cityName: string | null,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<BrandDiscoverModel[]>>;
}

export const brandService: IBrandService = {
  getMostPopular(categoryId, axiosConfig) {
    return ajax.get<Brand[]>(
      `${config.benefitApiUrl}/brands/most-popular/${categoryId}`,
      axiosConfig,
    );
  },
  getOnlineBrands(axiosConfig) {
    return ajax.get<BrandDiscoverModel[]>(
      `${config.benefitApiUrl}/brands/online`,
      axiosConfig,
    );
  },
  getBrandsByCity(cityName, axiosConfig) {
    return ajax.get<BrandDiscoverModel[]>(
      `${config.benefitApiUrl}/brands/${cityName}`,
      axiosConfig,
    );
  },
};
